/**
 * Object containing role identifiers for Ezlogic user permissions.
 *
 * Each property represents a specific user role, and its value is the unique numeric code
 * associated with that role in the system.
 *
 * @readonly
 * @enum {number}
 *
 * @property {number} BASIC_USER - Regular user with basic access rights.
 * @property {number} ACCOUNT_ADMINISTRATOR - User with administrative privileges for account management.
 * @property {number} NOTIFICATION_USER - User with access to notification features.
 * @property {number} ADVANCED_USER - User with advanced access rights and permissions.
 *
 */
export const PERMISSION_ROLES = {
    BASIC_USER: 9,
    ACCOUNT_ADMINISTRATOR: 10,
    NOTIFICATION_USER: 11,
    ADVANCED_USER: 13,
    PARTNER_USER: 5,
};
